import React from "react";

/**
 * One tab per terminal of the comercio ("Terminal 1", "Terminal 2"...), as the server lists them; the active one has
 * the accent. Arrow keys move the focus between tabs and Enter or a click loads that terminal (onSelect).
 */
export default function TerminalTabs({ terminales, activeId, onSelect }) {
  if (!Array.isArray(terminales) || !terminales.length) return null;
  const isActive = (terminal) => String(terminal.clienteId) === String(activeId);

  const handleKeyDown = (event) => {
    if (event.key !== "ArrowRight" && event.key !== "ArrowLeft") return;
    event.preventDefault();
    const tabs = Array.from(event.currentTarget.querySelectorAll('[role="tab"]'));
    const index = tabs.indexOf(document.activeElement);
    const step = event.key === "ArrowRight" ? 1 : -1;
    tabs[(index + step + tabs.length) % tabs.length]?.focus();
  };

  return (
    <div className="crm-ficha__tabs" role="tablist" aria-label="Terminales del comercio" onKeyDown={handleKeyDown}>
      {terminales.map((terminal, index) => {
        const selected = isActive(terminal);
        return (
          <button
            key={terminal.clienteId || index}
            type="button"
            role="tab"
            className="crm-ficha__tab"
            aria-selected={selected}
            tabIndex={selected ? 0 : -1}
            title={terminal.terminal || undefined}
            onClick={() => {
              if (!selected) onSelect?.(terminal);
            }}
          >
            {terminal.label || `Terminal ${index + 1}`}
          </button>
        );
      })}
    </div>
  );
}
